/** 房屋拆迁补偿标准  */
export const HOUSE_DEMOLITION_SPEC = [
  { label: '砖混（现浇）结构', key: 'zhuanHunXianJiaoJieGou' },
  { label: '砖混（预制）结构', key: 'zhuanHunYuZhiJieGou' },
  { label: '砖木结构（小青瓦）', key: 'zhuanMuJieGouXiaoQingWa' },
  { label: '土木、木结构（土墙小青瓦、砖墙草盖）', key: 'tuMuMuJieGou' },
  { label: '其他结构（土墙草盖、板房）', key: 'qiTaJieGou' },
  { label: '彩钢房', key: 'caiGangFang' },
  { label: '彩钢棚', key: 'caiGangPeng' },
  { label: '简易棚', key: 'jianYiPeng' },
  { label: '装饰、装修（含厕所、厨房）<b>简装</b>', key: 'zhuangShiZhuangXiuJianZhuang' },
  { label: '装饰、装修（含厕所、厨房）<b>一般</b>', key: 'zhuangShiZhuangXiuYiBan' },
  { label: '装饰、装修（含厕所、厨房）<b>精装</b>', key: 'zhuangShiZhuangXiuJingZhuang' }
]

/**
 * 生成房屋拆迁补偿标准数据源
 */
export const genHouseDemolitionStandardDataSource = (data: Record<string, any>) =>
  HOUSE_DEMOLITION_SPEC.map(item => ({
    type: item.label,
    standard: data?.[item.key],
    key: item.key
  }))

/**
 * 生成房屋拆迁补偿录入数据源
 */
export const genHouseDemolitionEntryDataSource = (data: Record<string, any>) =>
  HOUSE_DEMOLITION_SPEC.map(item => ({
    type: item.label,
    count: data?.[item.key],
    key: item.key
  }))

/** 拆迁不予安置的房屋拆迁奖励标准 */
export const REWARD_NO_RESETTLE_DATA_SOURCE = [
  { group: '围墙', type: '乱石垒、土围墙', unit: '立方米', key: 'liShiLeiTuWeiQiang' },
  { group: '围墙', type: '砖、石围墙', unit: '立方米', key: 'zhuanShiWeiQiang' },
  { group: '院（晒）坝', type: '三合土', unit: '平方米', key: 'sanHeTu' },
  { group: '院（晒）坝', type: '砖、石、水泥砂浆', unit: '平方米', key: 'zhuanShiShaiBa' },
  { group: '院（晒）坝', type: '石板坝', unit: '平方米', key: 'shiBanBa' },
  { group: '堡坎', type: '石堡坎', unit: '立方米', key: 'shiBaoKan' },
  { group: '堡坎', type: '砼', unit: '立方米', key: 'tongBaoKan' },
  { group: '堡坎', type: '砖', unit: '立方米', key: 'zhuanBaoKan' },
  { group: '堡坎', type: '其他', unit: '立方米', key: 'qiTaBaoKan' },
  { group: '水缸', type: '-', unit: '口', key: 'shuiGang' },
  { group: '地窖', type: '-', unit: '口', key: 'diJiao' },
  { group: '粪池', type: '土粪池', unit: '立方米', key: 'tuFenChi' },
  { group: '粪池', type: '水泥、三合土粪池', unit: '立方米', key: 'shuiNiFenChi' },
  { group: '粪池', type: '条石粪池', unit: '立方米', key: 'tiaoShiFenChi' },
  { group: '水池', type: '砣石、条石池', unit: '立方米', key: 'tuoShiTiaoShiChi' },
  { group: '水池', type: '石砌、砖砌、混凝土池', unit: '立方米', key: 'shiQiZhuanQiHunNingTuChi' },
  { group: '水池', type: '造型水池', unit: '立方米', key: 'zaoXingShuiChi' },
  { group: '灶台', type: '土灶', unit: '眼', key: 'tuZao' },
  { group: '灶台', type: '红砖砌灶', unit: '眼', key: 'hongZhuanQiZao' },
  { group: '灶台', type: '瓷砖灶、水泥灶', unit: '眼', key: 'ciZhuanZaoShuiNiZao' },
  { group: '灶台', type: '节能灶', unit: '眼', key: 'jieNengZao' },
  { group: '沼气池', type: '-', unit: '口', key: 'zhaoQiChi' },
  { group: '粮仓', type: '-', unit: '立方米', key: 'liangCang' },
  { group: '砖、石、混凝土柜', type: '-', unit: '立方米', key: 'zhuanShiHunNingTuGui' },
  { group: '围墙大门', type: '铁大门', unit: '平方米', key: 'tieDaMen' },
  { group: '围墙大门', type: '木大门', unit: '平方米', key: 'muDaMen' },
  { group: '围墙大门', type: '卷帘门', unit: '道', key: 'juanLianMen' },
  { group: '水塔', type: '-', unit: '立方米', key: 'shuiTa' },
  { group: '水井', type: '土水井', unit: '口', key: 'tuShuiJing' },
  { group: '水井', type: '条石水井', unit: '口', key: 'tiaoShiShuiJing' },
  { group: '水井', type: '压水井（含机械取水）', unit: '口', key: 'yaShuiJing' },
  { group: '水井', type: '机井（含抗旱井）', unit: '口', key: 'jiJing' },
  { group: '三相动力电（含基础）', type: '-', unit: '千瓦', key: 'sanXiangDongLiDian' },
  { group: '猪圈、牛圈', type: '筑石板、火砖（含设施、设备）', unit: '平方米', key: 'zhuShiBanHuoZhuan' },
  { group: '太阳能热水器', type: '-', unit: '个', key: 'taiYangNengReShuiQi' },
  { group: '个人出资自建入户水泥道路', type: '混泥土（含基础、堡坎）', unit: '平方米', key: 'hunNiTu' }
]
/**
 * 生成拆迁不予安置的房屋拆迁奖励表头
 */
export const genRewardNoResettleColumns = () => [
  {
    title: '项目名称',
    dataIndex: 'group',
    width: 200,
    customCell: (record, rowIndex) => {
      if (rowIndex === 0 || REWARD_NO_RESETTLE_DATA_SOURCE[rowIndex! - 1].group !== record.group) {
        const groupCount = REWARD_NO_RESETTLE_DATA_SOURCE.filter(item => item.group === record.group).length
        return {
          rowspan: groupCount
        }
      }
      return {
        rowspan: 0
      }
    }
  },
  {
    title: '类别',
    dataIndex: 'type',
    minWidth: 200
  },
  {
    title: '单位',
    dataIndex: 'unit',
    width: 100
  }
]
